export enum FillType {
  Solid = 'solid',
  Linear = 'linear',
  Radial = 'radial',
}
